module.exports = __webpack_public_path__ + "7ceb69ad788ec7cd1b6448664b7dde33.svg";